export default __webpack_public_path__ + "static/beauty-look-autumn-b1ce8597a6a96c31edabdd5c69a8eeea.jpg";